import React, { useState } from 'react';

import { Tabs } from '@mui/material';

import { Tab as StyledTab } from './Tab';

export interface Tab {
  id: string;
  name: string;
  onClick: () => void;
}

export interface TabsPanelProps {
  tabs: Tab[];
  disabled?: boolean;
  defaultTabId?: string;
}

const TabsPanel = ({ tabs, disabled, defaultTabId }: TabsPanelProps) => {
  const [currentTab, setCurrentTab] = useState<string>(defaultTabId || tabs[0].id);

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setCurrentTab(newValue);
  };

  return (
    <Tabs
      value={currentTab}
      onChange={handleChange}
      TabIndicatorProps={{
        style: {
          backgroundColor: '#FF8000',
        },
      }}
      variant="fullWidth"
    >
      {tabs.map((tab) => (
        <StyledTab
          disabled={disabled}
          key={tab.id}
          value={tab.id}
          onClick={tab.onClick}
          style={{ pointerEvents: 'auto' }}
          label={tab.name}
        />
      ))}
    </Tabs>
  );
};

export default TabsPanel;
